<div id="plans-page" [ngStyle]="{'marginTop':( isDesktop$ ) ? '220px' : '40px'}">
    <header>
        <h1>
            {{'nav.plans.title' | translate }}
        </h1>
    </header>


    @defer (on viewport) {
    <app-pricing></app-pricing>
    } @placeholder {
    <div></div>
    }

    <app-button style="width: fit-content;" type="discreet" [disabled]="true" (click)="openTokensPackModal()">{{
        'plans.buttons.buy_more_tokens' |
        translate}}</app-button>


    <app-button style="width: fit-content;" type="discreet" (click)="useBetaCode()">{{ 'beta.use_beta_code' |
        translate}}</app-button>



    <p>Besoin d'aide ? Pour obtenir de l'aide, résoudre des problèmes de tokens ou toute autre question,
        envoyez-nous un courriel à l'adresse suivante <a class="mailto"
            mailto="billing@;svet.com">billing&#64;svet.com</a> ou rendez-vous sur notre <a [href]="discordUrl">{{
            'socials.discord' | translate | titlecase }}</a>.</p>
    <p>{{ 'plans.contact_us' | translate}}</p>
</div>